import { Repository } from 'pinia-orm';
import { OrderBoxStatus } from '@/enums/commerce/OrderBoxStatus.enum.js';
import OrderBox from '@/models/commerce/OrderBox.js';
import OrderBoxItem from '@/models/commerce/OrderBoxItem.js';

export class OrderRepository extends Repository {
  use = OrderBox;
  getAllBoxes() {

    return this.repo(OrderBox)
      .orderBy('updatedAt', 'desc').get();

  }
  getOpenedBoxes() {
    return this.repo(OrderBox)
      .with('items')
      .with('summaries')
      .where('status', (status) =>
        [
          OrderBoxStatus.DRAFT,
          OrderBoxStatus.ACTIVE,
          OrderBoxStatus.READY,
          OrderBoxStatus.PACKED,
          OrderBoxStatus.SHIPPED,
        ].includes(status),
      )
      .orderBy('createdAt', 'desc').get();
  }
  getClosedBoxes() {
    return this.repo(OrderBox)
      .with('items')
      .with('summaries')
      .where('status', (status) =>
        [
          OrderBoxStatus.DELIVERED,
          OrderBoxStatus.CANCELLED,
          OrderBoxStatus.CLOSED,
        ].includes(status),
      )
      .orderBy('createdAt', 'desc').get();
  }
  getItems(){
    return this.repo(OrderBoxItem)
      .orderBy('status', 'desc');
  }
  availableBoxes() {
    return this.repo(OrderBox).orderBy('createdAt', 'desc');
  }


}
